/**
 * Set nested object value
 * @param {object} data object that will be updated.
 * @param {string} path we want to update inside the object.
 * @param {string} value new value of the given path.
 * @param {boolean} nnkao 'new number keys as object' when a new step is being created and
 *  its a number key initialize it as an object not an array. We introduced it because when
 *  we needed it when we're initializing a new answer in Flowy format.
 * @returns data object with updated value
 */
function snov(data: any, path: string, value: any, nnkao?: boolean): any {
  // This variable will 'move' through the object in order to point the part of the object that
  // will be updated
  let point = data;
  const steps = path.split('.');
  const last = steps.pop();

  steps.forEach(
    // This was the original code... dunno why I'm leaving it...
    // (step) => (point[step] = point[step] || {}) && (point = point[step])
    (step, index) => {
      const nextStep = steps[index + 1];

      // By default if the step has no value it initializes as an object
      let defaultValue: any = {};
      if (nextStep && !isNaN(+nextStep) && !nnkao) {
        // In the case the next step is a number this means it's an array so the
        // default value will be an array
        defaultValue = [];
      }
      point[step] = point[step] || defaultValue;
      point = point[step];
    }
  );

  if (last) {
    if (value !== undefined) {
      point[last] = value;
    } else {
      delete point[last];
    }
  }

  return data;
}

export default snov;
